import React from 'react';
import AlzaIcon from '../assets/AlzaIcon';
import MallIcon from '../assets/MallIcon';
import AllegroIcon from '../assets/AllegroIcon';
import KaufIcon from '../assets/KaufIcon';
import { ApiGroup } from '../api/model/ApiGroup';

interface Props {
  apiGroup: ApiGroup;
}

export default function ApiGroupIcon({ apiGroup }: Readonly<Props>): React.ReactElement | null {
  switch (apiGroup) {
    case ApiGroup.ALZA:
      return <AlzaIcon />;
    case ApiGroup.MALL_GROUP:
      return <MallIcon />;
    case ApiGroup.ALLEGRO:
      return <AllegroIcon />;
    case ApiGroup.KAUFLAND:
      return <KaufIcon />;
    default:
      return null;
  }
}
